export const DEFAULT_PAGE_SIZE = 30;


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/services-constants.ts